import React from 'react'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'

// Styled container using MUI's styled utility
const StyledContainer = styled('div')({
  color: 'white',
})

const CardCounter = ({ imageIds, currentIndex, fontSize, onClick }) => {
  fontSize = fontSize * 0.7
  const displayText =
    imageIds.length > 1 ? `${currentIndex + 1} / ${imageIds.length}` : ''

  return (
    <StyledContainer>
      {displayText && (
        <Button
          variant="contained"
          color="secondary"
          onClick={onClick}
          sx={{ p: 0, flexGrow: 0 }}
        >
          <Typography variant="body2" sx={{ fontSize }}>
            {displayText}
          </Typography>
        </Button>
      )}
    </StyledContainer>
  )
}

export default CardCounter
